"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = require("three");

var surface_1 = require("./surface");

var utils_1 = require("./utils");

var Plate =
/*#__PURE__*/
function () {
  function Plate() {
    _classCallCheck(this, Plate);

    this.surface = surface_1.surface;
    this.plateGeometry = new THREE.BoxGeometry();
    this.mesh = new THREE.Mesh();
  }

  _createClass(Plate, [{
    key: "update",
    value: function update(plateComponent) {
      this.plateGeometry = new THREE.BoxGeometry(plateComponent.scale.x, plateComponent.scale.y, plateComponent.scale.z);
      utils_1.adjustTextureMapping(this.plateGeometry, 1.0, 1.0);
      this.material = this.surface.getMaterial(plateComponent.material);
      this.mesh = new THREE.Mesh(this.plateGeometry, this.material);
      this.mesh.position.copy(plateComponent.position);
    }
  }]);

  return Plate;
}();

exports.default = Plate;